import React from "react"
import { useSelector } from "react-redux";
import { selectTeamLeadTags } from "../../slices/teamAndUserSettingsSlice";
import {
  AnalysisPanel,
  DataCell,
  HeaderCell,
  PanelIntro,
  TableHeaderRow,
  TableRow,
  TableShell,
  TableViewport,
} from "./ConfigurationTableLayout";

const tagPerformanceColumns = "minmax(16rem, 1.4fr) repeat(5, minmax(8.5rem, 0.8fr))"

const LeadTagPerformance = () => {
  const teamLeadTags = useSelector(selectTeamLeadTags)

  return (
    <AnalysisPanel>
      <PanelIntro>
        <span>This table tracks the outcomes when tags are applied to an investigation.</span>
        <span>Contact you App Administrator to propose new tags.</span>
      </PanelIntro>
      <TableShell>
        <TableViewport>
          <TableHeaderRow style={{gridTemplateColumns: tagPerformanceColumns}}>
            <HeaderCell $center>Tag Label</HeaderCell>
            <HeaderCell $center>Total times assigned</HeaderCell>
            <HeaderCell>Currently assigned to an Investigation</HeaderCell>
            <HeaderCell $tone="renegotiation">When Assigned - how often: <br/> a Renegotiation results</HeaderCell>
            <HeaderCell $tone="refinance">When Assigned - how often: <br/> a Refinance results</HeaderCell>
            <HeaderCell $tone="dismissal">When Assigned - how often: <br/> a Dismissal results</HeaderCell>
          </TableHeaderRow>
          {teamLeadTags.map((tag, index) => (
            <TableRow
              style={{gridTemplateColumns: tagPerformanceColumns}}
              $even={index%2 === 1}
              key={tag._id}
            >
              <DataCell $center>{tag.label}</DataCell>   
              <DataCell $center $strong={tag.assignments > 0}>
                {tag.currentAssignments}  
              </DataCell>   
              <DataCell $center $strong={tag.activeLeads > 0}>
                {tag.activeLeads}  
              </DataCell>   
              <DataCell $center $strong={tag.renegotiations > 0} $tone="renegotiation">
                {tag.renegotiations} {tag.assignments > 0 && (((tag.renegotiations/tag.assignments)*100).toFixed(0) + '%')}
              </DataCell>   
              <DataCell $center $strong={tag.refinances > 0} $tone="refinance">
                {tag.refinances} {tag.assignments > 0 && (((tag.refinances/tag.assignments)*100).toFixed(0) + '%')}
              </DataCell>   
              <DataCell $center $strong={tag.dismissals > 0} $tone="dismissal">
                {tag.dismissals} {tag.assignments > 0 && (((tag.dismissals/tag.assignments)*100).toFixed(0) + '%')}
              </DataCell>   
            </TableRow>
          ))}
        </TableViewport>
      </TableShell>
    </AnalysisPanel>
  )
}

export default LeadTagPerformance;
